import AgenciesCreationForm from '../../AgenciesCreationForm';

import styles from './AgencyInfoTab.module.scss';

const AgencyInfoTab = () => (
  <div className={styles.agencyInfoTab}>
    <AgenciesCreationForm />
  </div>
);

export default AgencyInfoTab;
